<template>

  <div :class="['c-text-renderer', {'c-text-renderer--code' : isCode === true}]">
    <article v-if="!isCode">{{text}}</article>
    <code v-else v-highlightjs="{ language: 'css', code: text }"></code>
  </div>
</template>

<script>
export default {
  components : {
  },
  props : ['note'],
  computed : {
    isCode : function() {
      if(this.note.type === 'code') {
        return true;
      }
      return false;
    },
    text : function() {
      return this.note.text;
    }
  }
}
</script>

<style lang="scss">
.c-text-renderer {
  font-size:var(--font-size);
  white-space: pre-line;

  &--code {
    padding:var(--size);
    border-radius: 5px;
    border:var(--g3) solid 1px;
    font-family: $font-family-monospace;
    font-size:var(--font-size-sm);
    background-color: var(--g4);
    white-space: break-spaces;
  }

  ::-moz-selection { /* Code for Firefox */
  color: initial;
  background: var(--danger);
  }

  ::selection {
    color:initial;
  background: var(--warning-color);
  }

}
</style>